export default __webpack_public_path__ + "static/media/folder.f642c095.png";